export const environment = {
  features: {
    signUp: true,
    sso: true,
    invitation: true,
  },
  // TODO: Move api key to generate_conf
  amity: {
    apiKey: 'b0efe859328ef66619378e1d535e16888400dfb0b3356b2f',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
